import { ReactNode } from 'react';
import { DefaultPageProps, IPhrases } from '@/types/types/page/pages';
import { NotificationLayout } from '@/components/blocks/Notification/notificationLayout';

interface MainContentWrapperProps {
    phrases?: IPhrases;
    dictionary?: DefaultPageProps['dictionary'];
    children?: ReactNode;
    className?: string;
    pageTitlePhraseId?: number;
    pageTitlePhrase?: string;
}

export const MainContentWrapper = ({ children, className }: MainContentWrapperProps) => {
    return (
        <main className={className}>
            <NotificationLayout />
            {children}
        </main>
    );
};
